import type { Permission, PermissionModule } from './types';

export const PERMISSION_MODULES: { value: PermissionModule; labelKey: string; icon: string }[] = [
  { value: 'auth', labelKey: 'permission.module.auth', icon: '🔐' },
  { value: 'users', labelKey: 'permission.module.users', icon: '👥' },
  { value: 'partners', labelKey: 'permission.module.partners', icon: '🤝' },
  { value: 'inventory', labelKey: 'permission.module.inventory', icon: '📦' },
  { value: 'rental', labelKey: 'permission.module.rental', icon: '🔧' },
  { value: 'sales', labelKey: 'permission.module.sales', icon: '🛒' },
  { value: 'service', labelKey: 'permission.module.service', icon: '🔨' },
  { value: 'reports', labelKey: 'permission.module.reports', icon: '📊' },
  { value: 'settings', labelKey: 'permission.module.settings', icon: '⚙️' },
];

export const MOCK_PERMISSIONS: Permission[] = [
  // Auth
  {
    id: 'p-001',
    code: 'auth.login',
    nameKey: 'permissions.auth.login',
    descriptionKey: 'permissions.auth.loginDesc',
    module: 'auth',
  },
  {
    id: 'p-002',
    code: 'auth.pin',
    nameKey: 'permissions.auth.pin',
    descriptionKey: 'permissions.auth.pinDesc',
    module: 'auth',
  },

  // Users
  {
    id: 'p-010',
    code: 'users.read',
    nameKey: 'permissions.users.read',
    descriptionKey: 'permissions.users.readDesc',
    module: 'users',
  },
  {
    id: 'p-011',
    code: 'users.create',
    nameKey: 'permissions.users.create',
    descriptionKey: 'permissions.users.createDesc',
    module: 'users',
  },
  {
    id: 'p-012',
    code: 'users.update',
    nameKey: 'permissions.users.update',
    descriptionKey: 'permissions.users.updateDesc',
    module: 'users',
  },
  {
    id: 'p-013',
    code: 'users.delete',
    nameKey: 'permissions.users.delete',
    descriptionKey: 'permissions.users.deleteDesc',
    module: 'users',
  },
  {
    id: 'p-014',
    code: 'users.roles',
    nameKey: 'permissions.users.roles',
    descriptionKey: 'permissions.users.rolesDesc',
    module: 'users',
  },

  // Partners
  {
    id: 'p-020',
    code: 'partners.read',
    nameKey: 'permissions.partners.read',
    descriptionKey: 'permissions.partners.readDesc',
    module: 'partners',
  },
  {
    id: 'p-021',
    code: 'partners.create',
    nameKey: 'permissions.partners.create',
    descriptionKey: 'permissions.partners.createDesc',
    module: 'partners',
  },
  {
    id: 'p-022',
    code: 'partners.update',
    nameKey: 'permissions.partners.update',
    descriptionKey: 'permissions.partners.updateDesc',
    module: 'partners',
  },
  {
    id: 'p-023',
    code: 'partners.delete',
    nameKey: 'permissions.partners.delete',
    descriptionKey: 'permissions.partners.deleteDesc',
    module: 'partners',
  },

  // Inventory
  {
    id: 'p-030',
    code: 'inventory.read',
    nameKey: 'permissions.inventory.read',
    descriptionKey: 'permissions.inventory.readDesc',
    module: 'inventory',
  },
  {
    id: 'p-031',
    code: 'inventory.receive',
    nameKey: 'permissions.inventory.receive',
    descriptionKey: 'permissions.inventory.receiveDesc',
    module: 'inventory',
  },
  {
    id: 'p-032',
    code: 'inventory.adjust',
    nameKey: 'permissions.inventory.adjust',
    descriptionKey: 'permissions.inventory.adjustDesc',
    module: 'inventory',
  },
  {
    id: 'p-033',
    code: 'inventory.transfer',
    nameKey: 'permissions.inventory.transfer',
    descriptionKey: 'permissions.inventory.transferDesc',
    module: 'inventory',
  },

  // Rental
  {
    id: 'p-040',
    code: 'rental.read',
    nameKey: 'permissions.rental.read',
    descriptionKey: 'permissions.rental.readDesc',
    module: 'rental',
  },
  {
    id: 'p-041',
    code: 'rental.create',
    nameKey: 'permissions.rental.create',
    descriptionKey: 'permissions.rental.createDesc',
    module: 'rental',
  },
  {
    id: 'p-042',
    code: 'rental.return',
    nameKey: 'permissions.rental.return',
    descriptionKey: 'permissions.rental.returnDesc',
    module: 'rental',
  },
  {
    id: 'p-043',
    code: 'rental.extend',
    nameKey: 'permissions.rental.extend',
    descriptionKey: 'permissions.rental.extendDesc',
    module: 'rental',
  },

  // Sales
  {
    id: 'p-050',
    code: 'sales.read',
    nameKey: 'permissions.sales.read',
    descriptionKey: 'permissions.sales.readDesc',
    module: 'sales',
  },
  {
    id: 'p-051',
    code: 'sales.create',
    nameKey: 'permissions.sales.create',
    descriptionKey: 'permissions.sales.createDesc',
    module: 'sales',
  },
  {
    id: 'p-052',
    code: 'sales.refund',
    nameKey: 'permissions.sales.refund',
    descriptionKey: 'permissions.sales.refundDesc',
    module: 'sales',
  },
  {
    id: 'p-053',
    code: 'sales.discount',
    nameKey: 'permissions.sales.discount',
    descriptionKey: 'permissions.sales.discountDesc',
    module: 'sales',
  },

  // Service
  {
    id: 'p-060',
    code: 'service.read',
    nameKey: 'permissions.service.read',
    descriptionKey: 'permissions.service.readDesc',
    module: 'service',
  },
  {
    id: 'p-061',
    code: 'service.create',
    nameKey: 'permissions.service.create',
    descriptionKey: 'permissions.service.createDesc',
    module: 'service',
  },
  {
    id: 'p-062',
    code: 'service.update',
    nameKey: 'permissions.service.update',
    descriptionKey: 'permissions.service.updateDesc',
    module: 'service',
  },
  {
    id: 'p-063',
    code: 'service.close',
    nameKey: 'permissions.service.close',
    descriptionKey: 'permissions.service.closeDesc',
    module: 'service',
  },

  // Reports
  {
    id: 'p-070',
    code: 'reports.sales',
    nameKey: 'permissions.reports.sales',
    descriptionKey: 'permissions.reports.salesDesc',
    module: 'reports',
  },
  {
    id: 'p-071',
    code: 'reports.rental',
    nameKey: 'permissions.reports.rental',
    descriptionKey: 'permissions.reports.rentalDesc',
    module: 'reports',
  },
  {
    id: 'p-072',
    code: 'reports.inventory',
    nameKey: 'permissions.reports.inventory',
    descriptionKey: 'permissions.reports.inventoryDesc',
    module: 'reports',
  },
  {
    id: 'p-073',
    code: 'reports.financial',
    nameKey: 'permissions.reports.financial',
    descriptionKey: 'permissions.reports.financialDesc',
    module: 'reports',
  },

  // Settings
  {
    id: 'p-080',
    code: 'settings.read',
    nameKey: 'permissions.settings.read',
    descriptionKey: 'permissions.settings.readDesc',
    module: 'settings',
  },
  {
    id: 'p-081',
    code: 'settings.update',
    nameKey: 'permissions.settings.update',
    descriptionKey: 'permissions.settings.updateDesc',
    module: 'settings',
  },
];

export const MOCK_TENANTS = [
  { id: 'tenant-001', name: 'Kisgépcentrum Központ' },
  { id: 'tenant-002', name: 'Kisgépcentrum Budaörs' },
  { id: 'tenant-003', name: 'Kisgépcentrum Győr' },
];

export function getPermissionsByModule(module: PermissionModule): Permission[] {
  return MOCK_PERMISSIONS.filter(p => p.module === module);
}
